module.exports = __webpack_public_path__ + "f5ac57aae7ab4403fb9afcdb394252c8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BN.svg
// module id = T+UH
// module chunks = 0